import React, { useState } from 'react';
import './Story.css';

const Story = ({ config }) => {
  const storyImages = config.content.story.images;
  const [selectedImage, setSelectedImage] = useState(storyImages[0]?.filename || 'story1.png');

  if (!config.content.story?.enabled) return null;

  return (
    <section id="story" className="story section">
      <div className="container">
        <h2 className="section-title" style={{ fontFamily: config.design.fonts.heading, color: config.design.colors.primary }}>
          {config.content.story.title}
        </h2>
        
        <div className="story-content-wrapper">
          {/* Image Gallery - Left Side */}
          <div className="story-image-gallery">
            <div className="story-image-circles">
              {storyImages.map((image) => (
                <button
                  key={image.id}
                  className={`story-circle ${selectedImage === image.filename ? 'active' : ''}`}
                  onClick={() => setSelectedImage(image.filename)}
                  style={{
                    backgroundImage: `url(/${image.filename})`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center'
                  }}
                  aria-label={`Select ${image.filename}`}
                />
              ))}
            </div>
            
            {/* Full Image Display */}
            <div style={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
              <div className="story-full-image-container">
                <img
                  src={`/${selectedImage}`}
                  alt="Our Story"
                  className="story-full-image"
                />
              </div>
            </div>
          </div>

          {/* Story Text - Right Side */}
          <div className="story-text" style={{ fontFamily: config.design.fonts.body, color: config.design.colors.secondary }}>
            {config.content.story?.text ? (
              config.content.story.text.split('\n').map((paragraph, index) => (
                <p key={index}>{paragraph}</p>
              ))
            ) : null}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Story;
